import { render, staticRenderFns } from "./TemplateFachliste.vue?vue&type=template&id=5504e308"
import script from "./TemplateFachliste.vue?vue&type=script&lang=js"
export * from "./TemplateFachliste.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports